import { render } from "./ContextMenuSub.vue?vue&type=template&id=3713d597&scoped=true"
import script from "./ContextMenuSub.vue?vue&type=script&lang=js"
export * from "./ContextMenuSub.vue?vue&type=script&lang=js"

import "./ContextMenuSub.vue?vue&type=style&index=0&id=3713d597&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3713d597"]])

export default __exports__